import { RetailerAccount } from '@promoboxx/graphql-gateway-types'
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { currentRetailerAccountSelector } from '@src/stores/app/selectors'

/**
 * Runs a function when the current Retailer Account changes, while skipping the
 * initial render.
 */
function useOnRetailerAccountChange(
  fn: (retailerAccount: RetailerAccount) => void,
) {
  // We need to use the given function in the effect but don't want it to be a
  // dependency, so use the ref+effect hack.
  const fnRef = useRef(fn)
  useEffect(() => {
    fnRef.current = fn
  })

  const currentRetailerAccount = useSelector(currentRetailerAccountSelector)

  const mountedRef = useRef(false)
  useEffect(() => {
    if (mountedRef.current) {
      fnRef.current(currentRetailerAccount)
    }
    mountedRef.current = true
  }, [currentRetailerAccount])
}

export default useOnRetailerAccountChange
